module.exports = __webpack_public_path__ + "img/4g_02.646fb508.png";